import { defineStore } from "pinia";
import { settings } from "~/content/settings";

export type SettingsState = {
  settings: {
    records: { fields: Record<string, any> }[];
  };
  loading: boolean;
};

export const useSettingsStore = defineStore("settings", {
  state: () =>
    ({
      settings: { records: [{ fields: settings }] },
      loading: false,
    }) as SettingsState,

  getters: {
    getPhone(state) {
      return state.settings.records[0]?.fields?.phone;
    },
    getAddress(state) {
      return state.settings.records[0]?.fields?.address;
    },
    getWorkTime(state) {
      return state.settings.records[0]?.fields?.workTime;
    },
  },

  actions: {
    // Данные теперь статичны (в репозитории). Метод оставлен для обратной
    // совместимости с вызовом в pages/index.vue.
    fetchSettings() {},
  },
});
